import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, WritableSignal, signal } from '@angular/core';
import { ParamMap } from '@angular/router';

@Injectable({
 providedIn: 'root',
})
export class UtmService {
 constructor(
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(DOCUMENT) private document: Document
 ) {}

 utmImageSource: WritableSignal<string> = signal('');
 utmQueryString = '';
 safarmarketId: WritableSignal<string> = signal('');

 setUtmImageSource(imageSource: string) {
  this.utmImageSource.set(imageSource);
 }

 isGoogleSource(queryParamMap: ParamMap): boolean {
  return this.getQueryParamIgnoreCase(queryParamMap, 'utm_source').trim().toLowerCase() === 'google';
 }

 isGoogleReferrer(): boolean {
  if (!isPlatformBrowser(this.platformId) || !this.document.referrer) return false;

  try {
   const hostname = new URL(this.document.referrer).hostname.toLowerCase();
   return /^(?:[a-z0-9-]+\.)*google\.(?:com|[a-z]{2,3}(?:\.[a-z]{2})?)$/.test(hostname);
  } catch {
   return false;
  }
 }

 checkRouteParams(queryParamMap: any) {
  let utm_source = this.getQueryParamIgnoreCase(queryParamMap, 'utm_source');
  let utm_medium = this.getQueryParamIgnoreCase(queryParamMap, 'utm_medium');
  let utm_content = this.getQueryParamIgnoreCase(queryParamMap, 'utm_content');
  let utm_campaign = this.getQueryParamIgnoreCase(queryParamMap, 'utm_campaign');

  if (!utm_medium) {
   utm_source = this.getCookie('utm_source');
   utm_medium = this.getCookie('utm_medium');
   utm_content = this.getCookie('utm_content');
  }

  const safarmarketIdFromQuery = this.getQueryParamIgnoreCase(queryParamMap, 'safarmarketId');
  const safarmarketId = [null, '', undefined].includes(safarmarketIdFromQuery)
   ? this.getCookie('safarmarketId')
   : safarmarketIdFromQuery;

  if (utm_medium && utm_content && utm_source) {
   let content = `utm_medium=${utm_medium}&utm_content=${utm_content}&utm_source=${utm_source}`;

   if (utm_campaign) {
    content += `&utm_campaign=${utm_campaign}`;
   }

   this.utmQueryString = content;
  }

  if (safarmarketId) {
   this.setSafarmarketId(safarmarketId);
   if (!this.utmQueryString.includes('safarmarketId')) {
    this.utmQueryString += this.utmQueryString
     ? `&safarmarketId=${safarmarketId}`
     : `safarmarketId=${safarmarketId}`;
   }
  }
 }

 private getQueryParamIgnoreCase(queryParamMap: any, name: string): string {
  if (!queryParamMap) return '';

  const direct = queryParamMap.get?.(name);
  if (direct != null && direct !== '') return direct;

  const keys: string[] = queryParamMap.keys ?? Object.keys(queryParamMap.params ?? {});
  const matchedKey = keys.find((key) => key.toLowerCase() === name.toLowerCase());
  if (!matchedKey) return '';

  return queryParamMap.get?.(matchedKey) ?? queryParamMap.params?.[matchedKey] ?? '';
 }

 private getCookie(name: string) {
  if (isPlatformBrowser(this.platformId)) {
   let ca: Array<string> = this.document.cookie.split(';');
   let caLen: number = ca?.length;
   let cookieName = `${name}=`;
   let c: string;

   for (let i: number = 0; i < caLen; i += 1) {
    c = ca[i].replace(/^\s+/g, '');
    if (c.indexOf(cookieName) == 0) {
     return c.substring(cookieName?.length, c?.length);
    }
   }
   return '';
  }
  return '';
 }

 private setSafarmarketId(safarmarketId: string) {
  this.safarmarketId.set(safarmarketId);
 }
}
